import React from "react";
import { reportClientError } from "../utils/errorReporting";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorMessage: "" };
  }

  static getDerivedStateFromError(error) {
    return {
      hasError: true,
      errorMessage: error?.message || "Unexpected application error"
    };
  }

  componentDidCatch(error, info) {
    console.error("ErrorBoundary caught error", error, info);
    void reportClientError({
      error,
      info,
      context: { source: "ErrorBoundary" }
    });
  }

  handleReload = () => {
    if (typeof window !== "undefined") {
      window.location.reload();
    }
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="App" style={{ display: "grid", placeItems: "center", minHeight: "100vh", padding: 20 }}>
          <div className="glass parent-card" style={{ width: "min(560px, 100%)" }}>
            <h2>Something went wrong</h2>
            <p style={{ opacity: 0.8 }}>
              The app hit an unexpected error. Reload to recover.
            </p>
            <small style={{ opacity: 0.65, display: "block", marginBottom: 12 }}>
              {this.state.errorMessage}
            </small>
            <button className="btn-nav success-btn" type="button" onClick={this.handleReload}>
              Reload app
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
